import(/* webpackMode: "eager" */ "/vercel/path0/website/node_modules/next/font/google/target.css?{\"path\":\"src/styles/theme/index.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/website/node_modules/next/font/google/target.css?{\"path\":\"src/styles/theme/index.ts\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/vercel/path0/website/src/app/ClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/vercel/path0/website/src/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieInitializer"] */ "/vercel/path0/website/src/components/CookieInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/website/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/website/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PerformanceTracker"] */ "/vercel/path0/website/src/components/PerformanceTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider","PostHogPageView"] */ "/vercel/path0/website/src/components/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/website/src/lib/auth/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/website/src/styles/globals.css");
